import React from 'react';

import { CREATE_NOTE } from '../../../common/graphql/note';
import NoteCreator from './NoteCreator';

const NoteCreatorView = props => {

	return (
		<NoteCreator
			{...props}
			createMutation={CREATE_NOTE}
		/>
	);
};

export default NoteCreatorView;
